import type { Resource } from '../../';
export const product_group_toddlers: Resource = {"default":"Toddler's"};
